import {
  Button,
  Dropdown,
  Input,
  MenuProps,
  Table,
} from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/store";
import { openNotificationWithIcon } from "../../../../../utils/helper";
import { getTeachers } from "../../../../../api/teachergroups/teachergroups";
import Invitemember from "../../teacherclasses/teacherclass/invitemember/invitemember";

const Teacherteachers = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
	const [showInviteMember, setShowInviteMember] = useState(false)

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
  }));

  const { user } = state;

	const closeShowInviteMember = () => {
		setShowInviteMember(false)
	}

  const fetchTeachers = async () => {
    try {
      setLoading(true);
      const res = await getTeachers(user?._id);
      const { data } = res?.data;
      let newData: any = [];
      data.subTeacher.forEach((item: any) => {
        newData.push(item);
      });
      setData(newData);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      if (error?.response) {
        openNotificationWithIcon(
          "error",
          "Get Teachers",
          `${error?.response?.data?.message || "Something went wrong"}`
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Get Teachers",
          "Something went wrong"
        );
      }
    }
  };

  useEffect(() => {
    fetchTeachers();

    // eslint-disable-next-line
  }, []);

  const items: MenuProps["items"] = [
    {
      key: `-open`,
      label: (
        <a
          rel="noopener noreferrer"
          href={`/teacher/profile}`}
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          Send email
        </a>
      ),
    },
    {
      key: `-send-message`,
      label: (
        <a
          rel="noopener noreferrer"
          href={`/teacher/profile}`}
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          View Stats
        </a>
      ),
    },
    {
      key: `-assign-tutorials`,
      label: (
        <a
          rel="noopener noreferrer"
          href={`/teacher/profile}`}
          onClick={(e) => {
            e.preventDefault();
          }}
          className="text-appcolorred"
          style={{
            color: "red",
          }}
        >
          Delete
        </a>
      ),
    },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text: any) => (
        <div>
          <p className="text-base font-medium text-appcolorpurplefaintone">
            Name
          </p>
          <p className="text-base text-appcolorpurplefaintone opacity-[0.5]">
            Email
          </p>
        </div>
      ),
    },
    {
      title: "Date Added",
      dataIndex: "age",
      key: "age",
      render: (text: any) => (
        <div>
          <p className="text-base text-appcolorpurplefaintone opacity-[0.5]">
            20/08/2021
          </p>
          <p className="text-sm text-appcolorpurplefaintone opacity-[0.5]">
            10:13AM
          </p>
        </div>
      ),
    },
    {
      title: "Last Active",
      dataIndex: "address",
      key: "address",
      render: (text: any) => (
        <div>
          <p className="text-base text-appcolorpurplefaintone opacity-[0.5]">
            20/08/2021
          </p>
          <p className="text-sm text-appcolorpurplefaintone opacity-[0.5]">
            10:13AM
          </p>
        </div>
      ),
    },
    {
      title: "More",
      dataIndex: "address",
      key: "address",
      render: (text: any) => (
        <div>
          <Dropdown menu={{ items }} placement="bottomRight">
            <img
              src="/img/vectors/more.svg"
              alt="more"
              className="w-8 h-5 cursor-pointer"
            />
          </Dropdown>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="text-[1.2rem] font-medium text-appcolorblackfaint">
          Teachers
        </h1>

        <div className="flex items-center ">
          <div className="flex items-center px-2 mr-4 rounded-lg w-fit bg-appcolorcream">
            <img src="/img/vectors/search.svg" alt="search" />
            <Input
              size="small"
              placeholder="Search record"
              bordered={false}
              className="w-full mr-4 custom-search-record full-input"
              onChange={(e: any) => {
                console.log(e.target.value);
              }}
            />
          </div>

          <div className="flex items-center">
            <div className="mr-[0.6rem] rounded-xl bg-appcolorgreyfaint p-[0.5rem]">
              <img
                src="/img/vectors/think.svg"
                alt="think"
                className="w-5 h-5 cursor-pointer"
              />
            </div>
            <Button
              className="custom-primary-two-btn extra-smaller-padding"
              onClick={() => {
								setShowInviteMember(true)
							}}
            >
              + Add New
            </Button>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <div className="flex items-center cursor-pointer">
          <div className="mr-[0.6rem] rounded-xl bg-appcolorgreyfaint p-[0.5rem]">
            <img
              src="/img/vectors/filter.svg"
              alt="think"
              className="w-5 h-5 cursor-pointer"
            />
          </div>

          <p className="mr-2 text-sm text-appcolorwhitefaintsix">Filter</p>
        </div>
      </div>

      <div className="mt-6">
        <Table dataSource={data} columns={columns} loading={loading} />
      </div>

      {showInviteMember ? (
        <Invitemember
          open={showInviteMember}
          closeModal={closeShowInviteMember}
          memberType={"teacher"}
        />
      ) : null}
    </div>
  );
};

export default Teacherteachers;
